// extracted by mini-css-extract-plugin
export default {"root":"Roe1l","button":"FTeqR","spinnerContainer":"kzSFc","spinner":"k9JiU","signInMainButton":"wu6_I","mobile":"JNOXU","smallMobile":"NWXzb","tablet":"kk1Qz","iconButton":"hiMbx"};